/* public function */
/* eslint-disable */

/* extract uri */
// instead of new URL()
export function getUri(href) {
  var dom = document.createElement('a');
  dom.href = href;
  return {
    protocol: dom.protocol,
    host: dom.host,
    hostname: dom.hostname,
    port: dom.port,
    origin: dom.origin
  }
}

// 获取字节长度
export function getByteLength(str) {
  let len = 0
  for (let i = 0; i < str.length; i++) {
    let a = str.charAt(i)
    if (a.match(/[^\x00-\xff]/gi) != null) {
      len += 2
    } else {
      len += 1
    }
  }
  return len
}

//  设置cookie
export function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires + ';domain=vanke.com;path=/;';
}

//  获取cookie
export function getCookie(cname) {
  var arr, reg = new RegExp("(^| )" + cname + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return (arr[2]);
  else
    return null;
}

// 删除cookie
export function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}
//权限过滤
export function permissionValidate(binding, projectData) {
  // 获取权限
  let permissionData = projectData,
    curPermission = {},
    flag = false,
    statusNum = 0;
  Array.isArray(permissionData) && permissionData.forEach(function (val) {
    if (val.action == binding) {
      curPermission = val;
      flag = true;
    }
  });
  if (!flag) {
    statusNum = 1;
  } else {
    let visible = curPermission.visible;
    let editable = curPermission.editable;
    if (!editable) {
      if (visible) {
        statusNum = 2;
      } else {
        statusNum = 1;
      }
    }
  }
  return statusNum;
}
//监测是否存在code
export function findCode(array, code) {
  let isExist = false;
  array.reduce((total, item, index) => {
    if (item.code == code) {
      isExist = true;
    }
  }, false)
  return isExist;
}

// 获取浏览器参数 返回JSON对象
export function getUrlParams() {
  let url = window.location.href
  let index = url.indexOf('?')
  if (index == -1) return {}
  let strParams = url.substr(index + 1)
  let strArr = strParams.split('&')
  let json = {}
  strArr.forEach(item => {
    let arr = item.split('=')
    json[arr[0]] = decodeURIComponent(arr[1])
  })
  return json
}
// 返回浏览器hash参数
export function urlParamsToString() {
  const urlJson = getUrlParams()
  let urlParams = ''
  for (const key in urlJson) {
    urlParams += key + '=' + urlJson[key] + '&'
  }
  return urlParams = urlParams.substr(0, urlParams.length - 1)
}

export function addClass(el, className) {
  if (el.classList) {
    el.classList.add(className)
  } else {
    el.className = `${el.className} ${className}`
  }
}
export function removeClass(el, className) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'), ' ');
  }
}
/* eslint-disable */



// WEBPACK FOOTER //
// ./src/uitls/index.js